<template>
  <b-container :class="`library-citrix-icons ${localeClass}`" fluid style="margin-top: 20px;">
    <b-row>
      <b-col>
        <template v-if="!UrlBuilder.isInternalUser">
          <home />
        </template>
        <template v-else>
          <tabbed-home-view />
        </template>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Home from './components/Home'
import TabbedHomeView from './components/TabbedHomeView'

export default {
  name: 'app',
  components: { 'home': Home, 'tabbed-home-view': TabbedHomeView },
  data () {
    return {
      timer: null
    }
  },
  computed: {
    localeClass () {
      if (this.$store.getters.person && this.$store.getters.person.preferences) {
        return this.$store.getters.person.preferences.locale
      }
      return ''
    },
    isLoginPath () {
      return this.$route.path.includes('/login')
    },
    isEmailPath () {
      return this.$route.path.includes('/email')
    }
  },
  mounted () {
    if (this.UrlBuilder.isInternalUser) {
      this.$store.commit('authenticated', { authenticated: false, token: null })
      sessionStorage.clear()
      if (this.$route.name === 'LicenseChecker') {
        this.$router.push('/la-007')
      } else if (this.route.name === 'Email') {
        this.$router.push(this.route.path)
      } else {
        this.$router.push('/login')
      }
    }
    this.timer = setInterval(() => {
      if (this.UrlBuilder.isInternalUser) {
        document.querySelector('.nav-tabs').style.borderBottom = (this.isLoginPath || this.isEmailPath)
          ? '1px solid transparent'
          : '1px solid #dee2e6'
      }
    }, 1)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>

<style lang="scss">
  @import "styles/fonts.scss";
  @import "~pylon-bootstrap-vue/dist/pylon-bootstrap-vue.css";
  @import "styles/variables.scss";

  body {
    font-family: "Citrix-Regular";
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: "Citrix-Semibold";
  }

  a {
    text-decoration: none !important;
  }

  #link {
    color: $primary;
  }

  .success-text {
    color: $success;
  }

  .primary-text {
    color: $primary;
  }

  .danger-text {
    color: $danger;
  }

  .warning-text {
    color: $warning;
  }

  .modal-dialog {
    max-width: 600px;
  }

  .modal-header {
    border-bottom-color: transparent;
  }

  .modal-title-link {
    font-size: 0.9rem;
    display: inline-block;
    margin-left: 20px;
  }

  .modal-body {
    overflow-wrap: break-word !important;
  }

  .modal-footer {
    border-top-color: transparent;
    height: 5px;
    padding: 0;
    margin: 0;
  }

  .flatpickr-wrapper {
    width: 100%;
  }

  .flatpickr-calendar:before, .flatpickr-calendar:after {
    display: none;
  }

  #datepicker-input.right + .flatpickr-calendar.static.open {
    right: -2px;
    top: 41px;
  }

  .custom-control-label:before {
    background-color: white;
    border: 1px solid $darkGray;
  }

  .error-checkbox .custom-control-input:checked~.custom-control-label:before,
  .error-checkbox .custom-control-input:checked~.custom-control-label:before {
    background-color: $danger;
    box-shadow: 0 0 0 1px #fff, 0 0 0 0.2rem rgba(213,0,50,.25)
  }

  .modal-input.right.dropdown .input-group .form-control {
    height: 48px;
    position: relative;
    border: none;
  }

  .modal-input.right.dropdown .input-group .form-control:focus {
    box-shadow: none;
  }

  .btn[disabled]:not(.search-btn) {
    background-color: $disabledGray !important;
    border-color: $disabledGray !important;
  }

  .typeahead-fieldset {
    position: relative;
  }

  .typeahead-fieldset .modal-input.right.dropdown .input-group .form-control {
    color: $darkGray;
  }

  /* Button color overrides */
  .btn-primary {
    background-color: $primary !important;
    border-color: $primary !important;
  }

  .btn-primary:hover {
    background-color: $primaryHover !important;
    border-color: $primaryHover !important;
  }

  .btn-success {
    background-color: $success !important;
    border-color: $success !important;
  }

  .btn-success:hover {
    background-color: $successHover !important;
    border-color: $successHover !important;
  }

  .btn-c-outline {
    background-color: $white !important;
    border-color: $primary !important;
    color: $primary !important;
  }

  .btn-c-outline:hover {
    background-color: $white !important;
    border-color: $primaryHover !important;
    color: $primaryHover !important;
  }

  .pagination > li:first-child > .page-link {
    border-top-left-radius: 25px;
    border-bottom-left-radius: 25px;
  }

  .pagination > li:last-child > .page-link {
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
  }

  .page-item.disabled .page-link {
    max-height: 38px !important;
  }

  .form-control-lg, .input-group-lg>.form-control, .input-group-lg>.input-group-append>.btn, .input-group-lg>.input-group-append>.input-group-text, .input-group-lg>.input-group-prepend>.btn, .input-group-lg>.input-group-prepend>.input-group-text {
    font-size: 1rem;
    min-height: 48px;
  }

  .loading-animation {
    animation: loading-spin infinite 1s linear;
  }
  @keyframes loading-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue